import { AppConstants } from '../app.constants';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/Rx';
import {HttpClient, HttpResponse} from '@angular/common/http';
import {ModelModel} from '../model/spring-model/model.model';
import {AuthenticationService} from './authentication.service';

@Injectable()
export class ModelService {

  constructor(private https: HttpClient, private  authService: AuthenticationService) { }
  getModelByMarkaS(markaId: number): Observable<HttpResponse<ModelModel[]>> {
    const apiURL = AppConstants.API_ENDPOINT_SPRING + 'model/marka/' + markaId;
    return this.https.get<ModelModel[]>(apiURL, {observe: 'response', headers: this.authService.getHeader()});
  }
}



// WEBPACK FOOTER //
// C:/Users/user/Desktop/otojet-git/OtojetUI-Spring-Admin-Project/src/app/service/model.service.ts